import { Component, Input, OnInit } from '@angular/core';

import { IColunaTexto } from '../../interface/icm-texto-generico';

@Component({
    selector: 'icm-coluna-texto',
    templateUrl: './view/icm-coluna-texto.component.html',
    styleUrls: ['./view/icm-coluna-texto.component.scss'],
})
export class IcmColunaTextoComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaTexto;
    @Input() carregando: boolean;

    texto: string;
    corTexto: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.texto = this.coluna.valor(this.linha);
        if (this.coluna?.cor) this.corTexto = this.coluna.cor(this.linha);
    }
}
